"use client";

import React from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
const plans = [{
  name: "Gold",
  description: "Premium club-wide exposure with high-impact branding and exclusive VIP matchday access.",
  monthlyPrice: "",
  yearlyPrice: "",
  popular: true,
  features: ["Primary logo on Senior playing kits", "Premium stadium perimeter signage", "VIP Matchday hospitality for 4 guests", "Full digital ecosystem integration", "Business Hub directory listing", "4 Season passes for home games"],
  buttonText: "Contact Us"
}, {
  name: "Silver",
  description: "Enhanced digital presence and training kit sponsorship for growing brands.",
  monthlyPrice: "",
  yearlyPrice: "",
  popular: false,
  features: ["Logo on training apparel", "Standard stadium perimeter signage", "Digital matchday program feature", "2 Season passes for home games", "Social media spotlight posts", "Invitation to annual gala"],
  buttonText: "Contact Us"
}, {
  name: "Bronze",
  description: "Support the local community and gain essential visibility at our home ground.",
  monthlyPrice: "",
  yearlyPrice: "",
  popular: false,
  features: ["Pitch-side perimeter signage", "Logo on official club website", "Social media shout-outs", "1 Season pass for home games", "Clubroom digital display logo"],
  buttonText: "Contact Us"
}, {
  name: "Presidents",
  description: "Exclusive inner-circle access and high-level networking opportunities.",
  monthlyPrice: "",
  yearlyPrice: "",
  popular: false,
  features: ["Naming rights for President's Lounge", "Exclusive board-level networking", "Premium VIP seating at all games", "Logo on official club stationery", "Quarterly strategy briefings"],
  buttonText: "Contact Us"
}, {
  name: "Signage",
  description: "Direct visual impact to thousands of visitors throughout the season.",
  monthlyPrice: "",
  yearlyPrice: "",
  popular: false,
  features: ["Custom 3m x 0.9m boundary board", "High-traffic location placement", "Logo on stadium entry boards", "Maintenance included for season"],
  buttonText: "Contact Us"
}, {
  name: "Player Sponsor",
  description: "Directly support an individual player's development and journey.",
  monthlyPrice: "",
  yearlyPrice: "",
  popular: false,
  features: ["Logo next to player profile online", "PA announcement on matchdays", "Signed player photo & jersey", "Meet & greet with sponsored player"],
  buttonText: "Contact Us"
}, {
  name: "Ground Naming Rights",
  description: "The ultimate branding opportunity with total facility integration.",
  monthlyPrice: "",
  yearlyPrice: "",
  popular: false,
  features: ["Official stadium naming rights", "External facility signage", "Mention in all media releases", "Primary digital map location"],
  buttonText: "Contact Us"
}, {
  name: "500 Club Member",
  description: "Join our exclusive community of dedicated supporters and local businesses.",
  monthlyPrice: "",
  yearlyPrice: "",
  popular: false,
  features: ["Exclusive 500 Club merchandise", "Name on the 500 Club honor board", "Discounted clubroom hire", "Voting rights at club AGM"],
  buttonText: "Contact Us"
}];
export default function SubscriptionPlans() {
  return <section data-section-id="224426" id="sponsorship-opportunities" className="py-20 bg-background text-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4 uppercase tracking-tighter">
            Sponsorship Opportunities
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            Partner with WT Birkalla and connect your brand with our passionate community. Support player development from Juniors to Seniors.
          </p>
        </div>

        <Tabs defaultValue="monthly" className="w-full flex flex-col items-center">
          <TabsList className="mb-12 bg-muted border border-border">
            <TabsTrigger value="monthly" className="px-8 py-2 text-base font-default data-[state=active]:bg-primary data-[state=active]:text-primary-foreground">Monthly</TabsTrigger>
            <TabsTrigger value="yearly" className="px-8 py-2 text-base font-default data-[state=active]:bg-primary data-[state=active]:text-primary-foreground">
              Annual <span className="ml-2 text-xs text-primary font-bold">(-15%)</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="monthly" className="w-full mt-0">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 items-stretch">
              {plans.map((plan, i) => <div key={plan.name} data-index={i} className={`relative flex flex-col p-8 rounded-lg bg-card transition-all duration-300 ${plan.popular ? "border-2 border-primary shadow-[0_0_20px_rgba(218,165,32,0.3)] md:-translate-y-4" : "border border-border shadow-md hover:shadow-lg"}`}>
                  {plan.popular && <Badge className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-primary text-primary-foreground hover:bg-primary/90 px-4 py-1 text-sm font-bold uppercase tracking-widest">
                      Most Impact
                    </Badge>}
                  
                  <div className="mb-6">
                    <h3 className="text-2xl font-bold font-default text-foreground mb-2 uppercase tracking-tight">{plan.name}</h3>
                    <p className="text-sm text-muted-foreground font-sans min-h-[40px]">{plan.description}</p>
                  </div>

                  <div className="mb-8">
                    {plan.monthlyPrice ? <>
                        <span className="text-4xl font-bold font-default text-primary">$ {plan.monthlyPrice}</span>
                        <span className="text-muted-foreground font-sans">/mo</span>
                      </> : <span className="text-2xl font-bold font-default text-primary uppercase">Custom Quote</span>}
                  </div>

                  <ul className="flex-1 space-y-4 mb-8">
                    {plan.features.map((feature, j) => <li key={j} data-index={j} className="flex items-start gap-3 font-sans text-sm text-foreground">
                        <Check className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                        <span>{feature}</span>
                      </li>)}
                  </ul>

                  <Button asChild variant={plan.popular ? "default" : "outline"} size="lg" className={`w-full font-bold text-base rounded-sm ${plan.popular ? "bg-primary hover:bg-primary/90 text-primary-foreground" : "border-primary text-primary hover:bg-primary hover:text-primary-foreground"}`}>
                    <Link to="/GetInTouchPage">{plan.buttonText}</Link>
                  </Button>
                </div>)}
            </div>
          </TabsContent>

          <TabsContent value="yearly" className="w-full mt-0">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 items-stretch">
              {plans.map((plan, i) => <div key={plan.name} data-index={i} className={`relative flex flex-col p-8 rounded-lg bg-card transition-all duration-300 ${plan.popular ? "border-2 border-primary shadow-[0_0_20px_rgba(218,165,32,0.3)] md:-translate-y-4" : "border border-border shadow-md hover:shadow-lg"}`}>
                  {plan.popular && <Badge className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-primary text-primary-foreground hover:bg-primary/90 px-4 py-1 text-sm font-bold uppercase tracking-widest">
                      Most Impact
                    </Badge>}
                  
                  <div className="mb-6">
                    <h3 className="text-2xl font-bold font-default text-foreground mb-2 uppercase tracking-tight">{plan.name}</h3>
                    <p className="text-sm text-muted-foreground font-sans min-h-[40px]">{plan.description}</p>
                  </div>

                  <div className="mb-8">
                    {plan.yearlyPrice ? <>
                        <span className="text-4xl font-bold font-default text-primary">$ {plan.yearlyPrice}</span>
                        <span className="text-muted-foreground font-sans">/yr</span>
                      </> : <span className="text-2xl font-bold font-default text-primary uppercase">Custom Quote</span>}
                  </div>

                  <ul className="flex-1 space-y-4 mb-8">
                    {plan.features.map((feature, j) => <li key={j} data-index={j} className="flex items-start gap-3 font-sans text-sm text-foreground">
                        <Check className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                        <span>{feature}</span>
                      </li>)}
                  </ul>

                  <Button asChild variant={plan.popular ? "default" : "outline"} size="lg" className={`w-full font-bold text-base rounded-sm ${plan.popular ? "bg-primary hover:bg-primary/90 text-primary-foreground" : "border-primary text-primary hover:bg-primary hover:text-primary-foreground"}`}>
                    <Link to="/GetInTouchPage">{plan.buttonText}</Link>
                  </Button>
                </div>)}
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </section>;
}